import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../settings/settings.service';
import { finalize } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantLogoService {

  constructor(
    private settingService: SettingsService,
    private router: Router
  ) {}

  fetchTenantLogo(): void {
    this.settingService.getTenantSetting()
      .pipe(
        finalize(() => {
          // Always executes (success or error)
          this.router.navigate(['/']);
        })
      )
      .subscribe({
        next: ({ metadata }) => {
          if (metadata?.[0]) {
            const tenantLogo = metadata[0]?.logo_file_name;
            if(tenantLogo && tenantLogo !== 'undefined' && tenantLogo !== 'null'){
                localStorage.setItem('tenantLogo', tenantLogo);
            }
          }
        },
        // Logo fetch failure is intentionally silent — finalize() ensures
        // navigation to '/' proceeds regardless, so the app still loads.
        error: () => {}
      });
  }
}
